"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProgressInfoItem = exports.ImgUploader = exports.retryAdapterEnhancer = exports.getSignature = exports.decryptToken = exports.isTimeout = void 0;
var SparkMD5 = require("spark-md5");
var CryptoJS = require("crypto-js");
var isTimeout = function (error) {
    return error.message.includes('timeout') || error.code === 'ECONNABORTED';
};
exports.isTimeout = isTimeout;
var decryptToken = function (token, reqId) {
    var iv = '1234567887654321';
    var result = CryptoJS.AES.decrypt(token, CryptoJS.enc.Utf8.parse(reqId), {
        iv: CryptoJS.enc.Utf8.parse(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return result.toString(CryptoJS.enc.Utf8);
};
exports.decryptToken = decryptToken;
var randomStr = function (len) {
    len = len || 32;
    var base = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var res = '';
    for (var i = 0; i < len; i++) {
        res += base[Math.floor(Math.random() * base.length)];
    }
    return res;
};
// 获取签名
var getSignature = function (reqId, biz) {
    var ts = Date.now().toString().substr(0, 10);
    var _randomStr = randomStr(6);
    var md5 = SparkMD5.hash(_randomStr + '@' + reqId + '@' + biz + '@shopee@' + ts);
    return _randomStr + '-' + md5 + '-' + ts;
};
exports.getSignature = getSignature;
var retryAdapterEnhancer = function (adapter, options) {
    var _a = options || {}, _b = _a.times, times = _b === void 0 ? 0 : _b, _c = _a.delay, delay = _c === void 0 ? 0 : _c;
    return function (config) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, retryTimes, _b, retryDelay, __retryCount, request;
        return __generator(this, function (_c) {
            _a = config.retryTimes, retryTimes = _a === void 0 ? times : _a, _b = config.retryDelay, retryDelay = _b === void 0 ? delay : _b;
            __retryCount = 0;
            request = function () { return __awaiter(void 0, void 0, void 0, function () {
                var _a, err_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 4]);
                            _a = [{}];
                            return [4 /*yield*/, adapter(config)];
                        case 1: return [2 /*return*/, __assign.apply(void 0, [__assign.apply(void 0, _a.concat([(_b.sent())])), { retry_count: __retryCount }])];
                        case 2:
                            err_1 = _b.sent();
                            // 判断是否进行重试
                            if (!retryTimes || __retryCount >= retryTimes) {
                                return [2 /*return*/, Promise.reject(err_1)];
                            }
                            __retryCount++; // 增加重试次数
                            return [4 /*yield*/, new Promise(function (resolve) {
                                    setTimeout(resolve, retryDelay);
                                }).then(request)];
                        case 3: // 增加重试次数
                        // 延时处理
                        return [2 /*return*/, _b.sent()];
                        case 4: return [2 /*return*/];
                    }
                });
            }); };
            return [2 /*return*/, request()];
        });
    }); };
};
exports.retryAdapterEnhancer = retryAdapterEnhancer;
var ImgUploader = /** @class */ (function () {
    function ImgUploader() {
    }
    return ImgUploader;
}());
exports.ImgUploader = ImgUploader;
function getProgressInfoItem(loaded, size) {
    return {
        total: size,
        loaded: loaded,
        percent: parseFloat((loaded / size).toFixed(2))
    };
}
exports.getProgressInfoItem = getProgressInfoItem;
